import "./Modal.css";
import React, { useState, useEffect, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { hideModal } from "../../../context/Actions/modal/modal";

const Modal = () => {
  const { modalState, modalDispatch } = useContext(PortalContext);
  const [animation, setAnimation] = useState("");
  const [component, setComponent] = useState("");
  const [flgComponent, setFlgComponet] = useState(false);
  const [params, setParams] = useState("");
  const [listBotones, setListBotones] = useState([]);
  const [posicion, setPosicion] = useState(["centro"]);
  const [bloquearDissmiss, setBloquearDissmiss] = useState(true);
  const [LoadedComponent, setLoadedComponent] = useState(null);

  const dissmiss = () => {
    if (!bloquearDissmiss) {
      setAnimation("");
      hideModal()(modalDispatch);
    }
  };

  const preventDissmiss = (event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    if (flgComponent) {
      setFlgComponet(false);
      setComponent(modalState.modal.data.template);
      setParams(modalState.modal.data.params);
    }
  }, [flgComponent]);

  useEffect(() => {
    if (
      modalState.modal.data !== undefined &&
      modalState.modal.data.template !== null &&
      modalState.modal.data.template !== undefined &&
      modalState.modal.data.template !== ""
    ) {
      if (
        modalState.modal.data.posicion !== undefined &&
        modalState.modal.data.posicion !== null &&
        modalState.modal.data.posicion !== ""
      ) {
        setPosicion(modalState.modal.data.posicion);
        switch (modalState.modal.data.posicion) {
          case "centro":
            setAnimation("desplazarCentro");
            break;
          case "centroAbajo":
            setAnimation("desplazarCentroAbajo");
            break;
          case "centroDerecha":
            setAnimation("desplazarCentroDerecha");
            break;
          default:
            setAnimation("desplazarCentro");
        }
      }
      setComponent(modalState.modal.data.template);
      setBloquearDissmiss(modalState.modal.data.bloquearDissmiss);
      setParams(modalState.modal.data.params);
      if (Array.isArray(modalState.modal.data.listBotones)) {
        setListBotones(modalState.modal.data.listBotones);
      } else {
        setListBotones([]);
      }
    }
  }, []);

  // Cargar componente dinámicamente cuando cambia el nombre
  useEffect(() => {
    if (component !== "" && component !== null && component !== undefined) {
      try {
        const DynamicComp = require("../../" + component).default;
        setLoadedComponent(() => DynamicComp);
      } catch (error) {
        console.error("Error loading modal component:", component, error);
        setLoadedComponent(null);
      }
    } else {
      setLoadedComponent(null);
    }
  }, [component]);

  return (
    <React.Fragment>
      <div className="fondo" onClick={dissmiss}>
        <div
          className={`modalContent ${animation} ${posicion}`}
          onClick={(e) => preventDissmiss(e)}
        >
          {LoadedComponent && React.createElement(LoadedComponent, params)}
          {Array.isArray(listBotones) && listBotones.length > 0 && (
            <div className="footerModal">
              {listBotones.map((item, i) => {
                return (
                  <button className={item.clase} onClick={item.accion} key={i}>
                    {item.text}
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
export default Modal;
